/**
 * Forgot Password page
 *
 * Initially displays a card with an email form. The email form, when submitted,
 * sends an email containing a link to reset the user's password (if the email)
 * is linked to an account. After the submit button is clicked, another card will
 * replace the email form with directions for resetting the password.
 */

import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { CardModule } from 'primeng/card';
import { ButtonDirective } from 'primeng/button';
import { EmrInputComponent } from "../../shared/emr-input/emr-input.component";

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    ButtonDirective,
    EmrInputComponent
  ],
})
export class ForgotPasswordPageComponent implements OnInit {
  email = new UntypedFormControl('', [Validators.required, Validators.email]);

  // Boolean for error messages
  invalidEmail = false;

  // Boolean to control what card is displayed
  emailSent = false;
  noEmailExists = false;

  constructor() { }

  ngOnInit(): void { }

  onSubmit() {
    // Check for errors
    if (!this.email.valid) {
      this.invalidEmail = true;
      this.noEmailExists = false;
    } else {
      this.sendEmail();
    }
  }

  /**
   * Send password reset email and redirect user to the login page after the reset
   */
  sendEmail() {
    const auth = getAuth();

    // Create ActionCodeSettings object to redirect back to login page after password reset
    const actionCodeSettings = {
      url: 'https://calvin-emr.web.app',
    };

    sendPasswordResetEmail(auth, this.email.value, actionCodeSettings)
      .then(() => {
        this.emailSent = true;
      })
      .catch((error) => {
        console.log(error);
        this.invalidEmail = false;
        this.noEmailExists = true;
      });
  }
}
